"use client";

import { BreadcrumbSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedBreadcrumbSection from "../Components/GeneratedBreadcrumbSection";

const Breadcrumb: FC<BreadcrumbSectionProps> = (props) => {
  return <GeneratedBreadcrumbSection {...props} />;
};

export default Breadcrumb;
